var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"pt-router-button",on:{"click":function($event){_vm.routeName === 'pt-router'
      ? _vm.$router.replace({ name: 'pt-view' })
      : _vm.$router.replace({ name: 'pt-router' })}}},[_c('r-icon',{attrs:{"name":"route","size":24,"color-type":_vm.routeName === 'pt-router' ? 'accent-primary' : ''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }